import { useState, useEffect } from 'react';
import _ from 'lodash';
import TextField from 'components/TextField';
import Button from 'components/Button';
import CheckBox from 'components/CheckBox';
import {
  Container,
  ItemGroup,
  Item,
  ProductLink,
  Description,
  Text,
} from 'styles/pages/browse-catalog/details.js';

const Products = ({ group, onProductsSave, syncGroupProducts }) => {
  const [products, setProducts] = useState(undefined);

  useEffect(() => {
    if (!products) {
      setProducts(group?.Products);
    }
  }, [products]);

  return (
    <Container>
      <ItemGroup style={{ gridTemplateColumns: 'repeat(6,1fr)' }}>
        {products?.map((item) => {
          return (
            <Item key={item.Product?.ID}>
              <ProductLink>
                <Description>
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    Visible&nbsp;
                    <CheckBox
                      checked={item?.Status === 'Active'}
                      onChange={(v) =>
                        setProducts(
                          products?.map((p) => {
                            if (p?.Product?.ID !== item?.Product?.ID) {
                              return p;
                            }
                            return {
                              ...p,
                              Status: !v ? 'InActive' : 'Active',
                            };
                          })
                        )
                      }
                    />
                  </div>
                  <img
                    src={item?.Product?.MarketingImagePath}
                    style={{
                      width: 100,
                      height: 100,
                      margin: '0 auto',
                      display: 'block',
                    }}
                  />
                  <Text
                    style={{
                      fontSize: 14,
                      paddingBottom: 20,
                      paddingTop: 20,
                    }}>
                    {item?.Product?.Name}
                  </Text>
                  <TextField
                    type='number'
                    label='Percentage Discount'
                    value={item?.Discount}
                    onChange={(v) => {
                      setProducts(
                        products?.map((p) => {
                          if (p?.Product?.ID !== item?.Product?.ID) {
                            return p;
                          }
                          return {
                            ...p,
                            Discount: v < 0 ? 0 : v > 100 ? 100 : Number(v),
                          };
                        })
                      );
                    }}
                  />
                </Description>
              </ProductLink>
            </Item>
          );
        })}
      </ItemGroup>
      <div style={{ position: 'fixed', bottom: 60, right: '6%' }}>
        <Button
          title='Submit'
          containerStyle={{
            backgroundColor: '#000',
            color: 'white',
            border: '2px solid black',
          }}
          onClick={() =>
            onProductsSave({
              groupName: group?.Name,
              products,
            })
          }
        />

        <Button
          title='Sync Products'
          containerStyle={{
            backgroundColor: '#fff',
            color: '#000',
            marginLeft: 20,
            border: '2px solid black',
          }}
          onClick={syncGroupProducts}
        />
      </div>
    </Container>
  );
};

export default Products;
